module.exports = __webpack_public_path__ + "static/media/cheekSquintRight.4159637a.obj";